// extracted by mini-css-extract-plugin
export default {"alignSelected":"TextDecorationInput_alignSelected__EVJys","textAlignInput":"TextDecorationInput_textAlignInput__q9w3g"};